/** PUNCTELE DE VERIFICARE ale unei bare, numite o singură dată.
 *
 *  O grindă, un stâlp și un panou de perete se verifică în aceleași locuri —
 *  fețele reazemelor și câmpul — iar numele lor stăteau scrise de TREI ori,
 *  în trei pași (`StepEforturi`, `StepArmareGrinzi`, `StepArmarePereti`), cu
 *  formulări care apucaseră deja să difere între ele. Aici e o singură
 *  definiție, iar cei trei pași o citesc.
 *
 *  Două lungimi, fiindcă ecranul cere două: numele SCURT stă în celula de
 *  tabel, cel LUNG în tooltipul ei.
 */
import { t } from "../i18n";
import type { Cheie } from "../i18n";

const LUNG: Record<string, Cheie> = {
  R1_sus: "struct.ef.punct_r1_sus",
  R1_jos: "struct.ef.punct_r1_jos",
  camp: "struct.ef.punct_camp",
  camp_V: "struct.ef.punct_camp_v",
  R2_sus: "struct.ef.punct_r2_sus",
  R2_jos: "struct.ef.punct_r2_jos",
  baza: "struct.ef.punct_baza",
  virf: "struct.ef.punct_virf",
};

const SCURT: Record<string, Cheie> = {
  R1_sus: "struct.ef.scurt_r1_sus",
  R1_jos: "struct.ef.scurt_r1_jos",
  camp: "struct.ef.scurt_camp",
  camp_V: "struct.ef.scurt_camp_v",
  R2_sus: "struct.ef.scurt_r2_sus",
  R2_jos: "struct.ef.scurt_r2_jos",
  baza: "struct.ef.scurt_baza",
  virf: "struct.ef.scurt_virf",
};

/** Ce ÎNSEAMNĂ punctul — textul de tooltip. Un punct necunoscut rămâne cum e:
 *  e codul lui, și e tot mai bun decât un gol. */
export const numelePunctului = (k: string): string =>
  (LUNG[k] ? t(LUNG[k]) : k);

/** Numele SCURT, pentru celula de tabel. */
export const punctScurt = (k: string): string => (SCURT[k] ? t(SCURT[k]) : k);
